<template>
  <div>
    <div class="auth auth_container">
      <div class="auth_wrapper">
        <a
          href="/"
          class="auth_logo-link"
        ><img
          height="98px"
          alt="Medicina.ru"
          src="../assets/med_logo.png"
        >
        </a>
        <h1 class="auth_header">
          Вход в личный кабинет эксперта
        </h1>
        <div class="text-center">
          Введите ваш логин и пароль выданный администратором<br>
          * Если забыли пароль, обратитесь к администратору АО "Медицина"
        </div>
        <span class="form_error"> {{ error }} </span>
        <form @submit.prevent="login">
          <input
            v-model="loginame"
            type="text"
            name="loginame"
            placeholder="Логин"
          >
          <input
            v-model="password"
            type="password"
            name="password"
            placeholder="Пароль"
          >
          <button type="submit">
            Вход
          </button>
        </form>
      </div>
    </div>
    <div class="auth_copy">
      <a
        href="https://www.medicina.ru/o-klinike/nagrady-sertifikaty-litsenzii-svidetelstva/#license-5"
        target="_blank"
      >
        <p>Лицензия ЛО 77-01-017705</p></a><p>© 1997-2020 Клиника АО «Медицина»</p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Login",
        data () {
            return {
                loginame: '',
                password: '',
                error: ''
            }
        },
        methods: {
            login () {
                this.$store
                    .dispatch('login', {
                        login: this.loginame,
                        password: this.password
                    })
                    .then(() => {
                        this.$router.push({ name: 'Home' }).catch(err => {console.log(err)})
                    })
                    .catch(err => {
                        this.error = 'Укажите правильный логин и пароль'
                        console.log(err)
                    })
            }
        }
    }
</script>

<style scoped>

  .form_error {
    z-index: 0;
    position: relative;
    padding: .2rem .5rem;
    color: #ef3340;
    line-height: 1;
  }
  .auth {
    font-size: 14px;
    color: #0a0a0a;
  }

  .auth_header {
    font-weight: 400;
    font-size: 1.6rem;
    position: relative;
    text-align: center;
    line-height: 1.8;
    margin: 10px 0;
  }

  .auth_header:after {
    content: "";
    position: absolute;
    display: block;
    width: 48px;
    height: 2px;
    background: #004b87;
    border-radius: 4px;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0;
  }
  .auth_logo-link {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: #004b87;
    font-family: Times,sans-serif;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .auth_container {
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-bottom: 0px;
    position: relative;
    box-sizing: content-box;
  }
  .auth_wrapper {
    padding: 0 1rem;
  }

  .auth_copy {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    bottom: 12px;
    left: 0;
    right: 0;
    font-size: 14px;
    line-height: 1.5;
  }
  .auth_copy, .auth_copy a {
    color: #5c5c5c;
  }
</style>
